module.exports = __webpack_public_path__ + "static/adidas-3ae33611eded0087afa2a9f084b390f9.svg";